module.exports = __webpack_public_path__ + "img/y-193.a3e21913.png";